// Machine-readable reasons the API sends as errors[0].code (backend: utils/validation-error.js).
// Branch on these, not on the message text, which is product copy and gets reworded.
export const AMBIGUOUS_EMAIL_CODE = 'multipleAccountsError'
